/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionDisputeDecision } from './CompetitionDisputeDecision';
import {
    CompetitionDisputeDecisionFromJSON,
    CompetitionDisputeDecisionFromJSONTyped,
    CompetitionDisputeDecisionToJSON,
    CompetitionDisputeDecisionToJSONTyped,
} from './CompetitionDisputeDecision';

/**
 * 
 * @export
 * @interface MatchDisputeResolutionDetail
 */
export interface MatchDisputeResolutionDetail {
    /**
     * 
     * @type {string}
     * @memberof MatchDisputeResolutionDetail
     */
    resolvedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchDisputeResolutionDetail
     */
    resolvedAt?: number;
    /**
     * 
     * @type {CompetitionDisputeDecision}
     * @memberof MatchDisputeResolutionDetail
     */
    decision?: CompetitionDisputeDecision;
    /**
     * 
     * @type {string}
     * @memberof MatchDisputeResolutionDetail
     */
    notes?: string;
}



/**
 * Check if a given object implements the MatchDisputeResolutionDetail interface.
 */
export function instanceOfMatchDisputeResolutionDetail(value: object): value is MatchDisputeResolutionDetail {
    return true;
}

export function MatchDisputeResolutionDetailFromJSON(json: any): MatchDisputeResolutionDetail {
    return MatchDisputeResolutionDetailFromJSONTyped(json, false);
}

export function MatchDisputeResolutionDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchDisputeResolutionDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : json['resolvedAt'],
        'decision': json['decision'] == null ? undefined : CompetitionDisputeDecisionFromJSON(json['decision']),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function MatchDisputeResolutionDetailToJSON(json: any): MatchDisputeResolutionDetail {
    return MatchDisputeResolutionDetailToJSONTyped(json, false);
}

export function MatchDisputeResolutionDetailToJSONTyped(value?: MatchDisputeResolutionDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolvedBy': value['resolvedBy'],
        'resolvedAt': value['resolvedAt'],
        'decision': CompetitionDisputeDecisionToJSON(value['decision']),
        'notes': value['notes'],
    };
}

